<template>
  <div :class="['slider-top-bar-container', { 'lightbox-top-bar': isLightboxView }]">
    <div class="view-mode-button-container">
      <div class="page-number">
        <FriedH3>{{ currentSlide + 1 + '/' + numOfSlides }}</FriedH3>
      </div>
      <FriedIconButton
        v-if="slides > 1"
        :class="['grid-view-button icon-button-dark', { active: isGridView }]"
        data-external="editor-button-slideshow-card-view"
        @click="$emit('toggle-grid-view', !isGridView)"
      >
        <FriedIcon icon="card" />
      </FriedIconButton>
      <router-link v-if="isLightboxView" v-slot="{ navigate }" :to="route" custom>
        <div role="link" @click="navigate">
          <FriedIconButton
            data-external="editor-button-slideshow-lightbox-view"
            @click="$emit('toggle-lightbox')"
          >
            <FriedIcon icon="arrow-collapse" />
          </FriedIconButton>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

const {
  isGridView,
  gridSlides = 1,
  slides = 1,
  currentSlide = 0,
} = defineProps<{
  isGridView?: boolean;
  isLightboxView?: boolean;
  route?: RouteLocationRaw;
  currentSlide?: number;
  slides?: number;
  gridSlides?: number;
}>();

defineEmits<{
  'toggle-grid-view': [boolean];
  'toggle-lightbox': [];
}>();

const numOfSlides = computed(() => {
  if (isGridView) {
    return gridSlides;
  }
  return slides;
});
</script>
<style lang="scss" scoped>
@import '@getaccept/lib-shared/src/assets/scss/icon-button-dark';

.slider-top-bar-container {
  position: absolute;
  z-index: 2;
  right: var(--spacing-150);
  top: var(--spacing-50);
  left: var(--spacing-150);

  @media screen and (max-width: $sm) {
    &.lightbox-top-bar {
      margin-top: var(--spacing-100);

      button {
        color: var(--white);
        background-color: var(--gray-60);
      }
    }
  }

  &.small {
    right: var(--spacing-150);
  }

  .view-mode-button-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: var(--spacing-50);
    align-items: center;

    .page-number {
      background-color: var(--text-dark);
      padding: var(--spacing-25) var(--spacing-50);
      border-radius: var(--radius-medium);

      .heading-3 {
        font-family: var(--default-font-family);
        margin: 0;
        color: var(--white);
      }
    }
  }
}
</style>
